import { useQuery, UseQueryOptions, UseQueryResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { axiosInstance } from '../../axios';
import { OrganizationsDataResponse } from '../../types';
import { OrganizationListItem, OrganizationsApiResponse } from './types';

/**
 * Selector organizacji (user / device). Ten sam backend co tabela ACS,
 * opakowany w `{ data: [...] }` bo tak czytają formularze.
 */
export const useGetOrganizationsFromFirestore = (
  options?: UseQueryOptions<OrganizationsDataResponse, AxiosError, OrganizationsDataResponse>,
): UseQueryResult<OrganizationsDataResponse, AxiosError> => useQuery<
OrganizationsDataResponse,
AxiosError,
OrganizationsDataResponse
>({
  queryKey: ['organizations-firestore'] as const,
  queryFn: async () => {
    const res = await axiosInstance.get<OrganizationsApiResponse<OrganizationListItem[]>>(
      '/v3-getOrganizationsCollection',
    );
    const list = res.data?.data;
    if (!Array.isArray(list)) {
      throw new Error('Nieoczekiwany kształt odpowiedzi /v3-getOrganizationsCollection');
    }
    return {
      data: list.map((item) => ({
        id: item.id,
        createdAt: item.createdAt ? new Date(item.createdAt).toISOString() : undefined,
        name: item.name,
        companyName: item.companyName,
        companyPhone: item.companyPhone,
        companyEmail: item.companyEmail,
        hotel: item.hotel,
        languages: item.languages,
      })),
    };
  },
  staleTime: 1000 * 60 * 5,
  refetchOnWindowFocus: false,
  ...options,
});
